// How the subscription reads in French (docs/specs/subscription-page). Every value comes from GET /api/subscription
// or the admin's listing; nothing here holds a price, an address or a duration.

export const PENDING = 'Modalités en cours de confirmation';

export const TAXES_WORDING = {
  before_taxes: 'avant taxes',
  taxes_included: 'taxes incluses',
};

export const PERIOD_WORDING = {
  month: 'par mois',
};

export const isReceived = (payment) => payment?.state === 'payment_received';

export const money = (cents, currency) =>
  new Intl.NumberFormat('fr-CA', { style: 'currency', currency }).format(cents / 100);

// A whole amount without its cents (« 12 $ », not « 12,00 $ »).
export const shortMoney = (cents, currency) =>
  new Intl.NumberFormat('fr-CA', {
    style: 'currency', currency, minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);

// « <price> par poste et par mois, avant taxes » (docs/specs/rc7, decision a); without the taxes while they are unset.
export const priceWording = (terms) => {
  const price = `${shortMoney(terms.price_per_seat_cents, terms.currency)} par poste et ${PERIOD_WORDING[terms.period]}`;
  return terms.taxes ? `${price}, ${TAXES_WORDING[terms.taxes]}` : price;
};

// What a person types in the amount field of a transfer: digits and a point, nothing else.
export const plainAmount = (cents) => (cents / 100).toFixed(2);

// An ISO date read as the local day it names (new Date('2026-11-22') would be midnight UTC, the day before here).
export const longDate = (iso) => {
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('fr-CA', { day: 'numeric', month: 'long', year: 'numeric' });
};

export const todayIso = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

export const stateLabel = (payment) =>
  isReceived(payment) ? `Paiement reçu le ${longDate(payment.received_on)}` : 'En attente du paiement';
